import React from 'react';
import styles from './styles';
import {IconTextButton, Form} from '@xpertdox_js/xdcomponents';
import {btn_c_lightRed, btn_c_lightGreen, font_s_md} from '@xpertdox_js/xdstyle';
import hasValueChanged from '../Hooks/hasValueChanged';
import parentStyles from '../styles';
import { validateValue } from '../../validation';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'
import EditedLogs from "../EditedLogs";
import subComponentStyles from "../subComponentStyles";

const InnerEditField = props => {
    // console.log('InnerEditField props', props)

    const {settings} = props;
    const [formState, setFormState] = React.useState({});
    const [manualHasChanged, setManualHasChanged] = React.useState(false);
    const { user } = React.useContext(UserContext)
    const { contextInstance } = React.useContext(InstanceContext)
    // default form settings
    const defaults = {
      // label: props.settings.title,
      id: 'editField_' + props.settings.diffProperty,
      labelStyles: {marginBottom: 0, paddingTop: 0, paddingBottom: '6px'},
      styles: {input: {...font_s_md}, textarea: {...font_s_md, minHeight: props.minfieldheight + 'px'}},
      value: props.valueState || props.value || props.settings.value,
      attributes: {autoFocus: true},
      notRequired: true,
    }

    const holdCallBack = value => {
        console.log(value, formState, "VALUE")
        propFormSettings[0].value = value.value;
        setFormState({[value.id]: value.value, hold: true})
    }

    const formSettings = [{
      type: 'text',
      id: 'edit_field',
      ...defaults,
    }]
    let propFormSettings = props.settings.formSettings ? [{
      ...defaults,
      ...props.settings.formSettings[0],
      value: defaults.value,
    }] : null;
    // default callback for certain fields to update and switch state to display on selection
    if (!props.customEditField && props.editable !== false && (
    propFormSettings[0].type === 'select'
    || propFormSettings[0].type === 'radio')) {
      propFormSettings[0].callback = value => {
        if(propFormSettings[0].holdCallBack && value.value === '<1') holdCallBack(value)
        else {
            props.changeState('display');
            props.setValueState(value.value);
        };
      }
    }

    const hasChanged = manualHasChanged ? true : hasValueChanged(settings.value, propFormSettings ? formState[propFormSettings[0].id] : props.valueState);

    const handleActivityLogUpdate = (_id) => {
      trackActivity({
        body: {
          _id,
          instance: contextInstance || user.instance,
          user: user.id
        }
      })
    }

    const handleSubmit = (value, custom = false) => {
      handleActivityLogUpdate(`InnerEditField.handleSubmit.(${value})`)
      const errorMsg = validateValue(props.settings.diffProperty, formState['editField_' + props.settings.diffProperty] || value, props.settings.valueToCompare);
      setFormState({
        ...formState,
        error: errorMsg
      })
      if (!errorMsg) {
        // console.log(value && value.value !== undefined ? value.value : formState['editField_' + props.settings.diffProperty], "VALUE")
        let valueToPass = value && value.value !== undefined ? value.value : formState['editField_' + props.settings.diffProperty];
        if(valueToPass === 'custom-null' && props.settings.formSettings && props.settings.formSettings[0] && props.settings.formSettings[0].defaultValue){
          valueToPass = props.settings.formSettings[0].defaultValue
        }
        props.setValueState(custom
          ? value
          : valueToPass
        );
        props.changeState('display');
      }
    };

    // ref for innerEditField container element
    const measureElem = React.useRef();

    // handle height event from innerEditField child
    const customFieldHeightHandler = () => {
        props.handleHeight('display', measureElem.current)
    }

    // set height of container on edit field activation
    React.useLayoutEffect(() => {
      if (measureElem.current && props.height !== measureElem.current.clientHeight) {
        props.handleHeight('edit', measureElem.current)
      }
    }, [props.height])

    const handleMeasure = React.useCallback(node => {
      if (node) props.handleHeight('edit', node);
    })

  const showUpdateBtn = () => {
      let returnValue = false;
      if(hasChanged) returnValue = true;
      if (props.settings && props.settings.formSettings && props.settings.formSettings[0].customUpdateBtn) returnValue = false
      return returnValue
  }

  return(
    <div style={styles.container} ref={handleMeasure}>
      {props.customEditField && props.customEditField({handleSubmit, handleHeight: customFieldHeightHandler})}
      {(!formState.hold && !props.customEditField) && <Form
            state={{formState, setFormState}}
            settings={propFormSettings}
            submitText='Update Value'
            styles={{submit: {display: 'none'}}}
            submitable={hasChanged}
            handleSubmit={handleSubmit}
      />}
      {formState.error && <div style={styles.errorMsg}>{formState.error}</div>}
      {props.settings.SubComponent && props.settings.SubComponent({
          handleSubmit,
          handleHeight: customFieldHeightHandler,
          subComponentStyles,
          setManualHasChanged,
          formState,
          setFormState
      })}
      {/* save update button */}
      {showUpdateBtn() &&
        <IconTextButton
          styles={styles.btn}
          preBuiltStyles={btn_c_lightGreen}
          size='sm'
          onClick={handleSubmit}
          icon='checkmark'
          text='Update Value'
        />
      }
      {/* clear button */}
      {(props.settings && props.settings.formSettings && props.settings.formSettings[0].defaultValue) &&
        <IconTextButton
          styles={styles.btn}
          preBuiltStyles={btn_c_lightRed}
          size='sm'
          onClick={() => handleSubmit({value: 'custom-null'})}
          icon='x'
          text='Reset'
        />
      }
      {/* cancel button */}
      <IconTextButton
        styles={styles.btn}
        preBuiltStyles={btn_c_lightRed}
        size='sm'
        onClick={() => { props.changeState('display'); handleActivityLogUpdate(`InnerEditField.handleActivityLogUpdate`) }}
        icon='x'
        text='Cancel'
      />
      {props.settings.editedLogs && <EditedLogs
          settings={propFormSettings}
          state={{formState, setFormState}}
          submit={handleSubmit}
          customProps={props.settings.editedLogsProps}
          data={props.settings.editedLogs}
      />}
    </div>
  )
}

export default InnerEditField;
